import { DriversState } from '../../types';

export const resetDriverFuelAssignments = (
  state: DriversState
) => {
  state.fuelAssignments.data = undefined;
  state.fuelAssignments.loadingStatus = undefined;
  state.fuelAssignments.paging = undefined;
}